export default "__VITE_ASSET__CxMnQYDV__"